import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

ProgressiveImage.propTypes = {
  lowQualitySrc: PropTypes.string.isRequired,
  highQualitySrc: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

function ProgressiveImage({ lowQualitySrc, highQualitySrc, className }) {
  const [src, setSrc] = useState(lowQualitySrc);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = highQualitySrc;
    img.onload = () => {
      setSrc(highQualitySrc);
      setLoading(false);
    };
  }, [lowQualitySrc, highQualitySrc]);

  return (
    <img
      src={src}
      className={className}
      style={{
        filter: loading ? 'blur(10px)' : 'none',
        transition: loading ? 'none' : 'filter 0.5s ease',
      }}
      draggable="false"
      alt="ProgressiveImage"
    />
  );
}

export default ProgressiveImage;
